module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "mdl-layout__content"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('h1', {
    staticClass: "mdl-typography--headline"
  }, [_vm._v("Avdeling")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('h2', {
    staticClass: "mdl-typography--title"
  }, [(_vm.department.id) ? _c('span', {
    domProps: {
      "textContent": _vm._s('ID ' + _vm.department.id)
    }
  }) : _c('span', [_vm._v("Ny")])]), _vm._v(" "), _c('div', {
    staticClass: "contact-info mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.department.name),
      expression: "department.name"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "id": "sample1"
    },
    domProps: {
      "value": (_vm.department.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.department, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "sample1"
    }
  }, [_vm._v("Navn")])]), _vm._v(" "), (_vm.errors.name) ? _c('div', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.errors.name)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.department.slug),
      expression: "department.slug"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "id": "sample2"
    },
    domProps: {
      "value": (_vm.department.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.department, "slug", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "sample2"
    }
  }, [_vm._v("Slug")])]), _vm._v(" "), (_vm.errors.slug) ? _c('div', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.errors.slug)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.department.email),
      expression: "department.email"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "id": "sample3"
    },
    domProps: {
      "value": (_vm.department.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.department, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "sample3"
    }
  }, [_vm._v("Epost")])]), _vm._v(" "), (_vm.errors.email) ? _c('div', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.errors.email)
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-bar"
  }, [_c('router-link', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored-grey",
    attrs: {
      "to": {
        name: 'editor'
      }
    }
  }, [_vm._v("Avbryt")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored-green",
    attrs: {
      "disabled": _vm.$root.ui.isLoading('department')
    },
    on: {
      "click": function($event) {
        return _vm.saveDepartment()
      }
    }
  }, [_vm._v("Save")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60b059bd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./reports/assets/src/components/EditorDepartment.vue
// module id = 66
// module chunks = 0